import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine12 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#00643C"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.42755 5.44019V18.6921H6.61199V8.27427C6.16147 8.63088 4.82894 9.32532 4.34086 9.56949L3.64616 9.9261L2.74512 7.89888L3.55225 7.52349C5.09138 6.79175 6.51807 5.90949 7.1186 5.44019H9.42755ZM15.4604 5.21506C17.7879 5.21506 19.9842 6.5288 19.9842 9.23167C19.9842 11.5028 18.5387 12.5353 16.9435 13.9805C16.2676 14.5998 14.9348 15.7075 14.766 16.4768H20.2283V18.6921H11.6314V16.9464C11.9692 15.4075 13.4893 14.0559 15.2538 12.5168C16.1363 11.7472 17.0935 10.8277 17.0935 9.55097C17.0935 8.40601 16.3427 7.48645 14.8972 7.48645C13.7335 7.48645 12.9266 8.33088 12.6076 8.68749L11.2184 6.8481C12.4949 5.74071 13.6774 5.21506 15.4604 5.21506Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgLine12);
export { ForwardRef as ReactComponent };
